import useSWR from "swr";

import { botConfigsEndpoints } from "../api";

export default function useHomeStats(userId: number | string | undefined) {
  const options = { revalidateOnFocus: false, keepPreviousData: false, dedupingInterval: 5 * 60 * 1000, errorRetryCount: 2 };
  const summary = useSWR(
    userId ? ["home-general-summary", userId] : null,
    () => botConfigsEndpoints.getMyGeneralStatsPerCurrency({ includeHistory: false }).then(({ data }) => data),
    options,
  );
  const history = useSWR(
    userId && summary.data ? ["home-general-history", userId] : null,
    () => botConfigsEndpoints.getMyGeneralStatsPerCurrency().then(({ data }) => data),
    options,
  );
  return { summary, history };
}
